import { render, staticRenderFns } from "./answer-questions.vue?vue&type=template&id=72e02a80&scoped=true&"
import script from "./answer-questions.vue?vue&type=script&lang=js&"
export * from "./answer-questions.vue?vue&type=script&lang=js&"
import style0 from "./answer-questions.vue?vue&type=style&index=0&id=72e02a80&lang=scss&scoped=true&"
import style1 from "./answer-questions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e02a80",
  null
  
)

export default component.exports